import React from "react";
import { Link } from "react-router-dom";
import { LuMail, LuPhone, LuMapPin, LuFacebook, LuLinkedin } from "react-icons/lu";
import BrandMark from "./BrandMark";
import BrandTagline from "./BrandTagline";

const SiteFooter = () => {
  return (
    <footer className="sv-footer">
      <div className="sv-container sv-footer__grid">
        <div>
          <BrandMark light className="sv-footer__brand" showTagline={false} />
          <BrandTagline light className="sv-brand-tagline--footer" withParens />
          <p className="sv-body" style={{ marginTop: "0.75rem" }}>
            Health is the Only Wealth! At Svasth, we prioritise your well-being
            with innovative solutions to ensure you live life to the fullest.
          </p>
          <div className="sv-footer__social">
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="sv-icon-btn"
            >
              <LuFacebook size={18} />
            </a>
            <a
              href="https://www.linkedin.com/company/alegion-health-tech-pvt-ltd/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="sv-icon-btn"
            >
              <LuLinkedin size={18} />
            </a>
          </div>
        </div>

        <div>
          <h4>Company</h4>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/product">Products</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
          </ul>
        </div>

        <div>
          <h4>Get in Touch</h4>
          <div className="sv-footer__meta">
            <div className="sv-contact__row">
              <LuMail size={18} />
              <span>tech@svasth.ai</span>
            </div>
            <div className="sv-contact__row">
              <LuPhone size={18} />
              <span>+91 960 006 8315</span>
            </div>
            <div className="sv-contact__row">
              <LuMapPin size={18} />
              <span>
                New No. 7C, Perumal Koil Street, Nerkundram, Chennai, Tamil Nadu
                600107
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="sv-container sv-footer__bottom">
        <span>© {new Date().getFullYear()}, All Rights Reserved</span>
        <span>
          <Link to="/privacy">Privacy Policy</Link>
          {" · "}
          <Link to="/terms">Terms & Conditions</Link>
        </span>
      </div>
    </footer>
  );
};

export default SiteFooter;
